import { THEME } from 'GlobalStyles';

export const DEFAULT_OPTIONS = {
  chartArea: { width: '88%', height: '75%' },
  fontName: THEME.typography.fontFamily,
  legend: { position: 'none' },
  series: {
    0: { lineWidth: 2 },
    1: { lineWidth: 1, lineDashStyle: [4, 4], color: THEME.palette.grey[700] } // Goal Line
  },
  vAxis: {
    viewWindow: {
      min: 0
    },
    baseline: 0,
    gridlines: { count: 4 },
    format: 'short'
  },
  animation: {
    startup: true,
    easing: 'inAndOut',
    duration: 1000
  }
};
